import React from "react";

import {
  TableSortLabel as MuiTableSortLabel,
  TableSortLabelProps,
} from "@mui/material";

export const TableSortLabel: React.FC<TableSortLabelProps> = (props) => {
  return <MuiTableSortLabel {...props}>{props.children}</MuiTableSortLabel>;
};
